// extracted by mini-css-extract-plugin
export default {"header":"ConfirmModal_header__SH1xK","headerTitle":"ConfirmModal_headerTitle__9c2sk","closeIcon":"ConfirmModal_closeIcon__09kdL"};